(function () {
  'use strict';

  var STORE_CURRENCY = 'USD';
  var STORAGE_KEY = 'bsm_currency_pref';
  var RATES_CACHE_KEY = 'bsm_currency_rates';
  var RATES_CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours

  var COUNTRY_TO_CURRENCY = {
    US:'USD',CA:'CAD',GB:'GBP',AU:'AUD',NZ:'NZD',IE:'EUR',DE:'EUR',FR:'EUR',IT:'EUR',ES:'EUR',
    PT:'EUR',NL:'EUR',BE:'EUR',AT:'EUR',FI:'EUR',GR:'EUR',LU:'EUR',MT:'EUR',CY:'EUR',SK:'EUR',
    SI:'EUR',EE:'EUR',LV:'EUR',LT:'EUR',HR:'EUR',ME:'EUR',XK:'EUR',AD:'EUR',MC:'EUR',SM:'EUR',
    VA:'EUR',IN:'INR',PK:'PKR',BD:'BDT',LK:'LKR',NP:'NPR',BT:'BTN',MV:'MVR',CN:'CNY',HK:'HKD',
    MO:'MOP',TW:'TWD',JP:'JPY',KR:'KRW',KP:'KRW',SG:'SGD',MY:'MYR',ID:'IDR',TH:'THB',VN:'VND',
    PH:'PHP',KH:'KHR',LA:'LAK',MM:'MMK',BN:'BND',TL:'USD',AE:'AED',SA:'SAR',QA:'QAR',KW:'KWD',
    BH:'BHD',OM:'OMR',JO:'JOD',LB:'LBP',IL:'ILS',PS:'ILS',IQ:'IQD',IR:'IRR',SY:'SYP',YE:'YER',
    TR:'TRY',EG:'EGP',LY:'LYD',TN:'TND',DZ:'DZD',MA:'MAD',EH:'MAD',SD:'SDG',SS:'SSP',ET:'ETB',
    ER:'ERN',DJ:'DJF',SO:'SOS',KE:'KES',UG:'UGX',TZ:'TZS',RW:'RWF',BI:'BIF',MZ:'MZN',ZM:'ZMW',
    ZW:'USD',MW:'MWK',ZA:'ZAR',NA:'NAD',BW:'BWP',SZ:'SZL',LS:'LSL',MG:'MGA',MU:'MUR',SC:'SCR',
    KM:'KMF',NG:'NGN',GH:'GHS',CI:'XOF',SN:'XOF',ML:'XOF',BF:'XOF',NE:'XOF',TG:'XOF',BJ:'XOF',
    GW:'XOF',CM:'XAF',TD:'XAF',CF:'XAF',CG:'XAF',GA:'XAF',GQ:'XAF',CD:'CDF',AO:'AOA',GM:'GMD',
    GN:'GNF',SL:'SLL',LR:'LRD',MR:'MRU',CV:'CVE',ST:'STN',RU:'RUB',UA:'UAH',BY:'BYN',
    MD:'MDL',GE:'GEL',AM:'AMD',AZ:'AZN',KZ:'KZT',UZ:'UZS',TM:'TMT',TJ:'TJS',KG:'KGS',MN:'MNT',
    AF:'AFN',PL:'PLN',CZ:'CZK',HU:'HUF',RO:'RON',BG:'BGN',RS:'RSD',BA:'BAM',MK:'MKD',AL:'ALL',
    CH:'CHF',LI:'CHF',NO:'NOK',SE:'SEK',DK:'DKK',IS:'ISK',FO:'DKK',GL:'DKK',
    BR:'BRL',AR:'ARS',CL:'CLP',CO:'COP',PE:'PEN',VE:'VES',EC:'USD',BO:'BOB',PY:'PYG',UY:'UYU',
    GY:'GYD',SR:'SRD',GF:'EUR',FK:'FKP',MX:'MXN',GT:'GTQ',BZ:'BZD',HN:'HNL',SV:'USD',NI:'NIO',
    CR:'CRC',PA:'USD',CU:'CUP',JM:'JMD',HT:'HTG',DO:'DOP',BS:'BSD',BB:'BBD',TT:'TTD',GD:'XCD',
    LC:'XCD',VC:'XCD',AG:'XCD',KN:'XCD',DM:'XCD',AI:'XCD',MS:'XCD',BM:'BMD',KY:'KYD',TC:'USD',
    VG:'USD',AW:'AWG',CW:'ANG',SX:'ANG',BQ:'USD',PR:'USD',FJ:'FJD',PG:'PGK',SB:'SBD',VU:'VUV',
    NC:'XPF',PF:'XPF',WF:'XPF',WS:'WST',TO:'TOP',TV:'AUD',KI:'AUD',NR:'AUD',PW:'USD',FM:'USD',
    MH:'USD',AS:'USD',GU:'USD',MP:'USD',NU:'NZD',CK:'NZD',TK:'NZD',NF:'AUD',CC:'AUD',CX:'AUD',
    IO:'USD',SH:'SHP',GI:'GIP',IM:'GBP',JE:'GBP',GG:'GBP',AX:'EUR',SJ:'NOK',BV:'NOK',HM:'AUD',
    TF:'EUR',GP:'EUR',MQ:'EUR',RE:'EUR',YT:'EUR',PM:'EUR',BL:'EUR',MF:'EUR'
  };

  var CURRENCY_SYMBOLS = {
    USD:'$',EUR:'€',GBP:'£',INR:'₹',PKR:'₨',JPY:'¥',CNY:'¥',KRW:'₩',
    AUD:'A$',CAD:'C$',NZD:'NZ$',CHF:'CHF',SEK:'kr',NOK:'kr',DKK:'kr',SGD:'S$',HKD:'HK$',AED:'د.إ',
    SAR:'﷼',BRL:'R$',MXN:'MX$',ZAR:'R',RUB:'₽',TRY:'₺',THB:'฿',IDR:'Rp',MYR:'RM',
    PHP:'₱',VND:'₫',BDT:'৳',LKR:'Rs',NPR:'Rs',NGN:'₦',EGP:'E£',KES:'KSh',
    XOF:'CFA',XAF:'FCFA',ILS:'₪'
  };

  var CURRENCY_NAMES = {
    USD:'US Dollar',EUR:'Euro',GBP:'British Pound',INR:'Indian Rupee',PKR:'Pakistani Rupee',
    JPY:'Japanese Yen',CNY:'Chinese Yuan',KRW:'South Korean Won',AUD:'Australian Dollar',
    CAD:'Canadian Dollar',NZD:'New Zealand Dollar',CHF:'Swiss Franc',SEK:'Swedish Krona',
    NOK:'Norwegian Krone',DKK:'Danish Krone',SGD:'Singapore Dollar',HKD:'Hong Kong Dollar',
    AED:'UAE Dirham',SAR:'Saudi Riyal',BRL:'Brazilian Real',MXN:'Mexican Peso',ZAR:'South African Rand',
    RUB:'Russian Ruble',TRY:'Turkish Lira',THB:'Thai Baht',IDR:'Indonesian Rupiah',MYR:'Malaysian Ringgit',
    PHP:'Philippine Peso',VND:'Vietnamese Dong',BDT:'Bangladeshi Taka',LKR:'Sri Lankan Rupee',
    NPR:'Nepalese Rupee',NGN:'Nigerian Naira',EGP:'Egyptian Pound',KES:'Kenyan Shilling',
    XOF:'West African CFA Franc',XAF:'Central African CFA Franc',ILS:'Israeli Shekel',
    PLN:'Polish Zloty',CZK:'Czech Koruna',HUF:'Hungarian Forint',RON:'Romanian Leu'
  };

  var POPULAR_CURRENCIES = ['USD','EUR','GBP','INR','PKR','AUD','CAD','AED','SAR','JPY','CNY',
    'SGD','MYR','ZAR','BRL','MXN','NGN','KES','EGP','TRY','RUB','IDR','PHP','THB','VND','BDT',
    'LKR','NPR','CHF','SEK','NOK','DKK','HKD','KRW','NZD','ILS','PLN','CZK','HUF','RON'];

  var state = {
    currency: STORE_CURRENCY,
    rate: 1,
    rates: null
  };

  function getSavedCurrency() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function saveCurrency(code) {
    try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
  }
  function getCachedRates() {
    try {
      var raw = localStorage.getItem(RATES_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts > RATES_CACHE_TTL) return null;
      return parsed.rates;
    } catch (e) { return null; }
  }
  function cacheRates(rates) {
    try { localStorage.setItem(RATES_CACHE_KEY, JSON.stringify({ ts: Date.now(), rates: rates })); } catch (e) {}
  }

  function fetchRates() {
    var cached = getCachedRates();
    if (cached) return Promise.resolve(cached);
    return fetch('https://open.er-api.com/v6/latest/' + STORE_CURRENCY)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rates = data && data.rates ? data.rates : {};
        cacheRates(rates);
        return rates;
      })
      .catch(function () { return {}; });
  }

  function detectCountry() {
    return fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.success !== false && data.country_code) return data.country_code;
        throw new Error('geo failed');
      })
      .catch(function () {
        return fetch('https://ipapi.co/json/')
          .then(function (r) { return r.json(); })
          .then(function (data) { return (data && data.country_code) || null; })
          .catch(function () { return null; });
      });
  }

  function formatMoney(amount, currency) {
    var symbol = CURRENCY_SYMBOLS[currency] || currency + ' ';
    var rounded = amount >= 100 ? Math.round(amount) : Math.round(amount * 100) / 100;
    var formatted;
    try {
      formatted = rounded.toLocaleString(undefined, { minimumFractionDigits: rounded % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
    } catch (e) { formatted = String(rounded); }
    return symbol + formatted;
  }

  function extractNumber(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }

  var PRICE_SELECTORS = [
    '.price .money', '.price-item', '.price__regular .price-item', '.price__sale .price-item',
    'span.money', '.product-price', '.cart-item__price-wrapper .money', '.totals__total-value',
    '[data-price]', '.price', '.cart-item__totals .money', '.quick-add-modal .money',
    '.hp-price', '.now', '.was'
  ];

  function convertPriceElements(root) {
    if (state.currency === STORE_CURRENCY) {
      restoreOriginalPrices(root);
      return;
    }
    var scope = root || document;
    var els = scope.querySelectorAll(PRICE_SELECTORS.join(','));
    els.forEach(function (el) {
      if (el.dataset.bsmSkip) return;
      if (el.children.length > 0 && !el.classList.contains('money')) return;
      var original = el.dataset.bsmOriginal || el.textContent.trim();
      if (!el.dataset.bsmOriginal) el.dataset.bsmOriginal = original;
      var num = extractNumber(original);
      if (num === null) return;
      var converted = num * state.rate;
      el.textContent = formatMoney(converted, state.currency);
    });
  }

  function restoreOriginalPrices(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-bsm-original]');
    els.forEach(function (el) {
      el.textContent = el.dataset.bsmOriginal;
    });
  }

  function applyCurrency(code) {
    state.currency = code;
    state.rate = code === STORE_CURRENCY ? 1 : (state.rates && state.rates[code]) || 1;
    saveCurrency(code);
    updateToggleLabel();
    convertPriceElements(document);
  }

  function updateToggleLabel() {
    var codeEl = document.getElementById('bsm-currency-code');
    if (codeEl) codeEl.textContent = state.currency;
  }

  function buildCurrencyList(filter) {
    var listEl = document.getElementById('bsm-currency-list');
    if (!listEl) return;
    listEl.innerHTML = '';
    var q = (filter || '').toLowerCase();
    POPULAR_CURRENCIES.forEach(function (code) {
      var name = CURRENCY_NAMES[code] || code;
      if (q && code.toLowerCase().indexOf(q) === -1 && name.toLowerCase().indexOf(q) === -1) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bsm-currency-option' + (code === state.currency ? ' is-selected' : '');
      btn.dataset.code = code;
      btn.innerHTML = '<span class="bsm-cc-code">' + code + '</span><span class="bsm-cc-name">' + name + '</span>';
      btn.addEventListener('click', function () {
        applyCurrency(code);
        toggleDropdown(false);
      });
      listEl.appendChild(btn);
    });
  }

  function toggleDropdown(force) {
    var dd = document.getElementById('bsm-currency-dropdown');
    if (!dd) return;
    var show = typeof force === 'boolean' ? force : dd.hasAttribute('hidden');
    if (show) { dd.removeAttribute('hidden'); buildCurrencyList(''); var s = document.getElementById('bsm-currency-search'); if (s) { s.value=''; setTimeout(function(){ s.focus(); }, 30); } }
    else { dd.setAttribute('hidden', ''); }
  }

  function initWidget() {
    var toggle = document.getElementById('bsm-currency-toggle');
    var search = document.getElementById('bsm-currency-search');
    if (toggle) toggle.addEventListener('click', function (e) { e.stopPropagation(); toggleDropdown(); });
    if (search) search.addEventListener('input', function () { buildCurrencyList(search.value); });
    document.addEventListener('click', function (e) {
      var widget = document.getElementById('bsm-currency-widget');
      if (widget && !widget.contains(e.target)) toggleDropdown(false);
    });
  }

  function init() {
    initWidget();
    var saved = getSavedCurrency();
    fetchRates().then(function (rates) {
      state.rates = rates;
      if (saved) {
        applyCurrency(saved);
        return;
      }
      detectCountry().then(function (countryCode) {
        var currency = (countryCode && COUNTRY_TO_CURRENCY[countryCode]) || STORE_CURRENCY;
        applyCurrency(currency);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { convertPriceElements(document); });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      var hasNew = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) hasNew = true;
        });
      });
      if (hasNew) convertPriceElements(document);
    });
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
